import { Suspense } from "react";
import { Spin } from "antd";
import { useRoutes } from "react-router";

import { ScrollbarOnScroll } from "@/components/ScrollbarOnScroll";

import { DocumentTitle } from "./DocumentTitle";
import { ScrollToTop } from "./ScrollToTop";
import { appRoutes } from "./routeConfig";

/** 读取 {@link ./routeConfig.tsx} */
export function AppRouter() {
  const tree = useRoutes(appRoutes);
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <Spin size="large" />
        </div>
      }
    >
      <DocumentTitle />
      <ScrollToTop />
      <ScrollbarOnScroll />
      {tree}
    </Suspense>
  );
}
